const multitabSinTurnoInitialState = {
    multitabSinTurno: {
      paso: 0,
    },
  };
  
  export default multitabSinTurnoInitialState;
  